import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'

export const useLazyQuery = (options) => {
    const queryClient = useQueryClient()
    const [isLoading, setIsLoading] = useState(false)

    const fetch = (onSuccess, onError) => {
        setIsLoading(true)
        queryClient
            .fetchQuery(options)
            .then((data) => {
                onSuccess && onSuccess(data)
            })
            .catch((error) => onError && onError(error))
            .finally(() => setIsLoading(false))
    }

    return { fetch, isLoading }
}

// Example of use:
// export const useInsightInfo = (insightKey) => {
//     const { isLoading: insightInfoLoading, fetch: fetchInsightInfo } = useLazyQuery({
//         queryKey: ['insightInfo', insightKey],
//         queryFn: () => getInsightInfo(insightKey),
//     })
//     return {
//         insightInfoLoading,
//         fetchInsightInfo,
//     }
// }
